import * as React from 'react';
import whyDidYouRender from '@welldone-software/why-did-you-render';

import ReactDOM from 'react-dom/client'
import App from './app.tsx'
import './index.css'
import EnsureVersion from "@app/verison";


if (import.meta.env.MODE === 'development') {
    whyDidYouRender(React, {
        include: [/.*/],
        exclude: [/^BrowserRouter/, /^Link/, /^Route/],
        trackAllPureComponents: true,
        trackHooks: true
    });

    startApp();
} else {
    startApp();
}


function startApp() {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <EnsureVersion>
                <App/>
            </EnsureVersion>
        </React.StrictMode>,
    )
}
